import React, { Component } from 'react';
import './index.scss';

export default class JobDetails extends Component {

  componentDidMount() {
    window.Grnhse.Iframe.load(this.props.match.params.id);
  }

  render() {
    return (
      <div id="grnhse_app"/>
    );
  }
}